.root {
    --fill-color: var(--white);
    --background-color: var(--pale-white);
}

.referenceSvg {
    position: absolute;
}

.logo {
    position: relative;
    background-color: var(--background-color);
    clip-path: var(--clip-path);
    width: 87px;
    height: 91px;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        animation: fill 4s ease-in-out infinite;
        background-image: linear-gradient(
            to top,
            var(--fill-color) 0%,
            var(--fill-color) 50%,
            transparent 50%,
            transparent 100%
        );
        scale: 1 2;
    }
}

@keyframes fill {
    0% {
        translate: 0 50%;
    }

    100% {
        translate: 0 -50%;
    }
}
